import React from "react";
import cx from "classnames";
import { Switch, Route, Redirect } from "react-router-dom";

// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import PortalNavbar from "components/Navbars/PortalNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import PropTypes from "prop-types";

import routes from "routes.js";

import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";

import axios from "axios";

import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";

const logo = require("assets/img/logo-white.svg").default;

const image = require("assets/img/sidebar-4.jpg").default;

axios.defaults.withCredentials = true;

//axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";

const { REACT_APP_SERVER_URL } = process.env;

var ps;

const useStyles = makeStyles(styles);

export default function Dashboard(props) {
  const { ...rest } = props;
  // states and functions
  const [reloadImagesUsers, setReloadImagesUsers] = React.useState(false);
  const [reloadTentatives, setReloadTentatives] = React.useState(false);
  const [reloadProjects, setReloadProjects] = React.useState(false);
  const [reloadStudies, setReloadStudies] = React.useState(false);
  const [reloadRegistrations, setReloadRegistrations] = React.useState(false);
  const [reloadAttendance, setReloadAttendance] = React.useState(false);
  const [reloadDataRequests, setReloadDataRequests] = React.useState(false);

  const [userState, setUserState] = React.useState({ access: 1 });
  const [allUsers, setAllUsers] = React.useState([]);
  const [allTentatives, setAllTentatives] = React.useState([]);
  const [allMembers, setAllMembers] = React.useState([]);
  const [allProjects, setAllProjects] = React.useState([]);
  const [allRegistrations, setAllRegistrations] = React.useState([]);
  const [allAttendance, setAllAttendance] = React.useState([]);
  const [allStudies, setAllStudies] = React.useState([]);
  const [allImages, setAllImages] = React.useState([]);
  const [allDataRequests, setAllDataRequests] = React.useState([]);
  const [miniActive, setMiniActive] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const { user } = useAuth0();

  // styles
  const classes = useStyles();
  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1,
    });
  // ref for main panel div
  const mainPanel = React.createRef();
  // effect instead of componentDidMount, componentDidUpdate and componentWillUnmount
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);

    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  });

  async function getImageData() {
    let images = [];

    try {
      images = await axios.get(`${REACT_APP_SERVER_URL}/images`, {
        headers: {
          pragma: "no-cache",
        },
      });
    } catch ({ response }) {
      images = response;
    }

    if (images.severity) {
      images = [];
    } else {
      images = images.data.images;
    }

    setAllImages(images);
    getUserData(images); /// To make sure User gets appropriate profile image

    return images;
  }

  React.useEffect(() => {
    getImageData(); // This executes when the reload state changes which happens when the child components update the callback such as adding or deleting a new user
  }, [reloadImagesUsers]);

  async function getUserData(images) {
    let userInfo =
      user && user.name
        ? {
            type: "attendee",
            email: user.email,
            email_verified: user.email_verified,
          }
        : { type: "basic" };

    let users = {};

    try {
      users = await axios.get(`${REACT_APP_SERVER_URL}/users`, {
        headers: {
          pragma: "no-cache",
        },
      });
    } catch ({ response }) {
      users = response;
    }

    if (users.severity) {
      users = [];
    } else {
      users = users.data.users;
    }

    const userName = user && user.name.toLowerCase();

    const findEmailIndex = ({ email }) => {
      //return email == authUserObj.email;
      return email == userName;
    };

    const emailIndex = users.findIndex(findEmailIndex);

    const usersData = users[emailIndex];

    if (usersData) {
      userInfo = usersData;

      const userImage = images.filter((file) => {
        //const fileExt = file.split(".").pop();

        return file.includes("profile___" + usersData.id + "___");
      });

      userInfo.userImage = userImage[0];
    }

    //// Access Levels
    //// 1: Basic - basic anyone that visits site without logging in
    //// 2: Logged in not verified  -- attende
    //// 3: Logged in and verified  - attendee
    /// 3.5 research_coordinator
    //// 4: Member - member
    //// 5: Admin - member_admin and admin

    // Member - member or member_admin

    const access =
      userInfo.type == "admin" || userInfo.type == "member_admin"
        ? 5
        : userInfo.type == "member"
        ? 4
        : userInfo.type == "research_coordinator"
        ? 3.5
        : userInfo.type == "attendee" && userInfo.email_verified
        ? 3
        : userInfo.type == "attendee"
        ? 2
        : 1;

    const member =
      userInfo.type == "member_admin" || userInfo.type == "member"
        ? true
        : false;

    userInfo.access = access;
    userInfo.member = member;

    const members = users.filter(
      (user) => user.type == "member" || user.type == "member_admin",
    );

    setUserState(userInfo);
    setAllUsers(users);
    setAllMembers(members);
    setReloadImagesUsers(false); /// Turns reload state back to false after fetching data

    return members;
  }

  async function getTentativeData() {
    let tentatives = {};

    try {
      tentatives = await axios.get(`${REACT_APP_SERVER_URL}/tentatives`, {
        headers: {
          pragma: "no-cache",
        },
      });
    } catch ({ response }) {
      console.log("ERROR WITH TENTATIVES");
      tentatives = response;
    }

    if (tentatives.severity) {
      tentatives = [];
    } else {
      tentatives = tentatives.data.tentatives;
    }

    setAllTentatives(tentatives);
    setReloadTentatives(false); /// Turns reload state back to false after fetching data

    return tentatives;
  }

  React.useEffect(() => {
    getTentativeData(); // This executes when the reload state changes which happens when the child components update the callback such as adding or deleting a new user
  }, [reloadTentatives]);

  async function getProjectData() {
    let projects = [];

    try {
      projects = await axios.get(`${REACT_APP_SERVER_URL}/projects`, {
        headers: {
          pragma: "no-cache",
        },
      });
    } catch ({ response }) {
      projects = response;
    }

    if (projects.severity) {
      projects = [];
    } else {
      projects = projects.data.projects;
    }

    setAllProjects(projects);
    setReloadProjects(false); /// Turns reload state back to false after fetching data

    return projects;
  }

  React.useEffect(() => {
    getProjectData(); // This executes when the reload state changes which happens when the child components update the callback such as adding or deleting a new user
  }, [reloadProjects]);

  async function getAttendanceData() {
    let attendance = [];

    try {
      attendance = await axios.get(`${REACT_APP_SERVER_URL}/attendance`, {
        headers: {
          pragma: "no-cache",
        },
      });
    } catch ({ response }) {
      attendance = response;
    }

    if (attendance.severity) {
      attendance = [];
    } else {
      attendance = attendance.data.attendance;
    }

    setAllAttendance(attendance);
    setReloadAttendance(false); /// Turns reload state back to false after fetching data

    return attendance;
  }

  React.useEffect(() => {
    getAttendanceData(); // This executes when the reload state changes which happens when the child components update the callback such as adding or deleting a new user
  }, [reloadAttendance]);

  async function getStudies() {
    let studies = [];

    try {
      studies = await axios.get(`${REACT_APP_SERVER_URL}/studies`, {
        headers: {
          pragma: "no-cache",
        },
      });
    } catch ({ response }) {
      studies = response;
    }

    if (studies.severity) {
      studies = [];
    } else {
      studies = studies.data.studies;
    }

    setAllStudies(studies);
    setReloadStudies(false);
  }

  React.useEffect(() => {
    getStudies(); // This executes when the reload state changes which happens when the child components update the callback such as adding or deleting a new user
  }, [reloadStudies]);

  async function getRegistrations() {
    let registrations = [];

    try {
      registrations = await axios.get(`${REACT_APP_SERVER_URL}/registrations`, {
        headers: {
          pragma: "no-cache",
        },
      });
    } catch ({ response }) {
      registrations = response;
    }

    if (registrations.severity) {
      registrations = [];
    } else {
      registrations = registrations.data.registrations;
    }

    setAllRegistrations(registrations);
    setReloadRegistrations(false); /// Turns reload state back to false after fetching data

    return registrations;
  }

  React.useEffect(() => {
    getRegistrations(); // This executes when the reload state changes which happens when the child components update the callback such as adding or deleting a new user
  }, [reloadRegistrations]);

  async function getDataRequests() {
    let dataRequests = [];

    try {
      dataRequests = await axios.get(`${REACT_APP_SERVER_URL}/data_requests`, {
        headers: {
          pragma: "no-cache",
        },
      });
    } catch ({ response }) {
      dataRequests = response;
    }

    if (dataRequests.severity) {
      dataRequests = [];
    } else {
      dataRequests = dataRequests.data.dataRequests;
    }

    setAllDataRequests(dataRequests);
    setReloadDataRequests(false); /// Turns reload state back to false after fetching data

    return dataRequests;
  }

  React.useEffect(() => {
    getDataRequests(); // This executes when the reload state changes which happens when the child components update the callback such as adding or deleting a new user
  }, [reloadDataRequests]);

  // functions for changeing the states from components

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/portal/full-screen-maps";
  };

  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  const history = useHistory();
  const goHome = () => {
    let path = `/portal/highlights`;
    history.push(path);
  };

  const getRoutes = (routes) => {
    const adminRoutes = ["/portal/admin"];
    const memberRoutes = ["/portal/profile", "/portal/studies"];
    const attendeeRoutes = ["/portal/my_conferences"];

    if (userState.access < 5 && adminRoutes.includes(props.location.pathname)) {
      //Require admin acces for users page
      goHome();
    }

    if (
      userState.access < 4 &&
      memberRoutes.includes(props.location.pathname)
    ) {
      //Require admin acces for users page
      goHome();
    }
    if (
      userState.access < 3 &&
      attendeeRoutes.includes(props.location.pathname)
    ) {
      //Require admin acces for users page
      goHome();
    }

    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/portal") {
        return (
          <Route
            path={prop.layout + prop.path}
            render={(props) => (
              <prop.component /// Giving props to child components - the callBack setReload will update this component and cause a new fetch of users when a child component updates
                {...props}
                users={allUsers}
                tentatives={allTentatives}
                members={allMembers}
                projects={allProjects}
                studies={allStudies}
                registrations={allRegistrations}
                attendance={allAttendance}
                dataRequests={allDataRequests}
                images={allImages}
                userInfo={userState}
                reloadImagesUsersCallBack={setReloadImagesUsers}
                reloadTentativesCallBack={setReloadTentatives}
                reloadProjectsCallBack={setReloadProjects}
                reloadStudiesCallBack={setReloadStudies}
                reloadRegistrationsCallBack={setReloadRegistrations}
                reloadAttendanceCallBack={setReloadAttendance}
              />
            )}
            //component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"PREVENT"}
        logo={logo}
        userInfo={userState}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={"blue"}
        bgColor={"black"}
        miniActive={miniActive}
        {...rest}
      />
      <div className={mainPanelClasses} ref={mainPanel}>
        <PortalNavbar
          sidebarMinimize={sidebarMinimize.bind(this)}
          miniActive={miniActive}
          brandText={getActiveRoute(routes)}
          handleDrawerToggle={handleDrawerToggle}
          userInfo={userState}
          reloadImagesUsersCallBack={setReloadImagesUsers}
          {...rest}
        />
        {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>
              <Switch>
                {getRoutes(routes)}
                <Redirect from="/portal" to="/portal/dashboard" />
              </Switch>
            </div>
          </div>
        ) : (
          <div className={classes.map}>
            <Switch>
              {getRoutes(routes)}
              <Redirect from="/portal" to="/portal/dashboard" />
            </Switch>
          </div>
        )}
        {getRoute() ? <Footer fluid /> : null}
      </div>
    </div>
  );
}

Dashboard.propTypes = {
  location: PropTypes.Object,
};
